import { render, staticRenderFns } from "./FormSelectNew.vue?vue&type=template&id=0af5fa34&"
import script from "./FormSelectNew.vue?vue&type=script&lang=js&"
export * from "./FormSelectNew.vue?vue&type=script&lang=js&"
import style0 from "./FormSelectNew.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports